import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ExpandableVerticalSections.css";

const sectionsData = [
  {
    id: 1,
    title: "Strategy Teams",
    content: (
      <div className="build_for_reports_block">
      <div className="">
        <div className="strat_teams_block">
          <h5 className="strat_teams_head">Strategy Teams</h5>
          <div className="strat_number_blocks">
            <div className="left_block">
              <div className="left_subblock">
                <p className="left_subhead">Faster <br/> Planning</p>
                <p className="left_number">75%</p>
              </div>
              <div className="left_image_block">
                <img src="/img/login/faster_planning.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>
            <div className="right_block">
              <div className="right_subblock">
                <p className="right_subhead">Cost <br/> Savings</p>
                <p className="right_number">$500K+</p>
              </div>
              <div className="right_image_block">
                <img src="/img/login/cost_savings.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>

          </div>
          <div className="strat_list_block">
          <ul class="tab_left_ul">
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Accelerate planning cycles from quarters to weeks</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Replace multiple research subscriptions</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Enable continuous strategy refinement</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Support data-driven decision-making</span>
                    </li>
                </ul>

          </div>
        </div>


     
      </div>
    </div>
    ),
  },
  {
    id: 2,
    title: "Sales Leadership",
    content: (
      <div className="build_for_reports_block">
      <div className="">
        <div className="strat_teams_block">
          <h5 className="strat_teams_head">Sales Leadership</h5>
          <div className="strat_number_blocks">
            <div className="left_block">
              <div className="left_subblock">
                <p className="left_subhead">Win Rate <br/> Increase</p>
                <p className="left_number">40%</p>
              </div>
              <div className="left_image_block">
                <img src="/img/login/faster_planning.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>
            <div className="right_block">
              <div className="right_subblock">
                <p className="right_subhead">Deal <br/> Velocity</p>
                <p className="right_number">2x</p>
              </div>
              <div className="right_image_block">
                <img src="/img/login/cost_savings.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>

          </div>
          <div className="strat_list_block">
          <ul class="tab_left_ul">
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Arm teams with real-time competitive intel</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Enable account-specific market intelligence</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Accelerate qualification with opportunity analysis</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Support strategic selling</span>
                    </li>
                </ul>

          </div>
        </div>


     
      </div>
    </div>
    ),
  },
  {
    id: 3,
    title: "Consulting Teams",
    content: (
      <div className="build_for_reports_block">
      <div className="">
        <div className="strat_teams_block">
          <h5 className="strat_teams_head">Consulting Teams</h5>
          <div className="strat_number_blocks">
            <div className="left_block">
              <div className="left_subblock">
                <p className="left_subhead">Capacity <br/> Increase</p>
                <p className="left_number">3x</p>
              </div>
              <div className="left_image_block">
                <img src="/img/login/faster_planning.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>
            <div className="right_block">
              <div className="right_subblock">
                <p className="right_subhead">Cost <br/> Savings</p>
                <p className="right_number">-85%</p>
              </div>
              <div className="right_image_block">
                <img src="/img/login/cost_savings.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>

          </div>
          <div className="strat_list_block">
          <ul class="tab_left_ul">
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Reduce research phase from weeks to hours</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Increase project capacity without adding headcount</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Deliver higher-quality insights</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Focus on analysis, not research</span>
                    </li>
                </ul>

          </div>
        </div>


     
      </div>
    </div>
    ),
  },
  {
    id: 4,
    title: "Executive Leadership",
    content: (
      <div className="build_for_reports_block">
      <div className="">
        <div className="strat_teams_block">
          <h5 className="strat_teams_head">Executive Leadership</h5>
          <div className="strat_number_blocks">
            <div className="left_block">
              <div className="left_subblock">
                <p className="left_subhead">Decision <br/> Speed</p>
                <p className="left_number">10x</p>
              </div>
              <div className="left_image_block">
                <img src="/img/login/faster_planning.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>
            <div className="right_block">
              <div className="right_subblock">
                <p className="right_subhead">Consulting <br/> Reduction</p>
                <p className="right_number">-60%</p>
              </div>
              <div className="right_image_block">
                <img src="/img/login/cost_savings.png" className="img_icon" alt="payment icon"/>
              </div>
            </div>

          </div>
          <div className="strat_list_block">
          <ul class="tab_left_ul">
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Make faster, informed strategic decisions</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Reduce dependency on external consulting</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Enable evidence-based growth strategy</span>
                    </li>
                    <li class="tab_left_list">
                        <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                            >Gain visibility into opportunities</span>
                    </li>
                </ul>

          </div>
        </div>


     
      </div>
    </div>
    ),
  },
];

export default function ExpandableVerticalSections() {
  const [activeId, setActiveId] = useState(1);

  return (
    <div className="d-flex bg-light vertical_block">
      {sectionsData.map((section) => {
        const isActive = activeId === section.id;
        return (
          <div
            key={section.id}
            onClick={() => setActiveId(section.id)}
            className={`panel d-flex ${
              isActive ? "active" : "inactive"
            }`}
          >
            <h4 className="inactive_head">{section.title}</h4>
            {isActive && <div className="content_custom">{section.content}</div>}
          </div>
        );
      })}
    </div>
  );
}
